'use client';

import React from 'react';

import WidgetHeader from 'src/components/Profiles/shared/widgets/WidgetHeader';
import { Card } from 'src/components/PulseUI';
import WidgetLoading from 'src/components/Profiles/shared/widgets/shared/WidgetLoading';
import WidgetEmpty from 'src/components/Profiles/shared/widgets/shared/WidgetEmpty';
import { useWidgetConfig } from 'src/context/providers/WidgetConfigProvider';
import { useProfile } from 'src/context/providers/ProfileProvider';
import { formatCurrency } from 'src/utils/formatCurrency/formatCurrency';
import { useGetPatientVisitValueQuery } from 'src/api/redux';

const PatientVisitValue: React.FC = () => {
  const widgetConfig = useWidgetConfig();
  const widget = widgetConfig?.widget ?? null;
  const { entityDetails } = useProfile();

  const codeSetId = widget?.code_set?.id;
  const entityId = entityDetails?.id;
  const codeSetLabel = widgetConfig?.filterSet?.label
    ? `${widgetConfig.filterSet.label} Claims`
    : 'All Claims';

  const { data, isLoading } = useGetPatientVisitValueQuery(
    { entityId: entityId ?? '', codeSetId: codeSetId ?? 0 },
    { skip: !entityId || !codeSetId }
  );

  return (
    <Card
      className="p-5 flex flex-col gap-2 bg-white h-full"
      data-testid="patient-visit-value"
      role="region"
      aria-label="Patient Visit Value"
    >
      <WidgetHeader fallbackTitle={`Slot Value - ${codeSetLabel}`} />
      <div className="flex-1 min-h-0 overflow-y-auto">
        {isLoading ? (
          <WidgetLoading data-testid="patient-visit-value-loading" className="flex items-center justify-center py-8" />
        ) : data?.patient_visit_value == null ? (
          <WidgetEmpty data-testid="patient-visit-value-empty" variant="full" />
        ) : (
          <div
            className="flex flex-col gap-1"
            data-testid="patient-visit-value-content"
          >
            <span className="text-xs text-neutral-400">
              Their current 15min slot value derived from reimbursement data from{' '}
              {widgetConfig?.dateRangeLabel}
            </span>
            <span
              className="text-3xl font-bold text-sky-900 tabular-nums mt-2"
              data-testid="patient-visit-value-amount"
            >
              {formatCurrency(data.patient_visit_value, {
                abbreviated: false,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};

export default PatientVisitValue;
